/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import LastInstallment from './LastInstallment/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Installment/Content/Expandable/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let payerDataValueData = fromData.useDataFormat({ viewPath,
context: 'payer',
path: 'data',
format: fromHelpers.getInstallmentText,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let payerDataInstallmentValueData = fromData.useDataFormat({ viewPath,
context: 'payer',
path: 'data.installment',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pb-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={11}
 color={dtColorsNeutral600}
 data="payer.data"
 format="helpers.js getInstallmentText"
 text={payerDataValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={11}
 weight="semibold"
 data="payer.data.installment"
 format="/Data/format.js numberMoney"
 text={payerDataInstallmentValueData}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<LastInstallment
  viewPath={`${viewPath}/LastInstallment`}
/>
</div>
{children}
</React.Fragment>)
}